<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Extra-dim Overlay (same as login/reset) -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <!-- =========================
       CONTENT LAYER (Split Screen)
  =========================== -->
  <div class="container-fluid position-relative z-1 min-vh-100">
    <div class="row d-flex min-vh-100">

      <!-- Left illustration/marketing column (show from md and up, same as login/reset) -->
      <div class="col-6 col-md-6 d-none d-md-flex bg-warning text-white login-panel-left">
        <div class="d-flex flex-column justify-content-center align-items-center vh-100 w-100 px-5">
          <div class="absolute-top-left">
            <router-link
              to="/"
              class="auth-logo mb-2 text-decoration-none d-inline-block"
              aria-label="NPI Home"
            ></router-link>
          </div>

          <h3 class="fw-bold mb-4 text-dark">
            Manage Your B-BBEE Compliance with Confidence
          </h3>
          <p class="text-dark text-sm">
            Track programmes, prepare audit packs, and achieve your target BEE level with our comprehensive platform.
          </p>
        </div>
      </div>

      <!-- Right column: create new password form (same structure as login/reset) -->
      <div class="col-12 col-md-6 d-flex align-items-center justify-content-center vh-100 flex-column">
        <div class="p-4 p-md-5 login-panel">

          <!-- Heading -->
          <h3 class="fw-bold mb-1 text-white">
            Create New Password
          </h3>

          <p class="text-white-50 mb-4 text-sm">
            Enter your new password below.
          </p>

          <!-- Error -->
          <div
            v-if="error_message"
            class="alert alert-danger alert-dismissible fade show rounded-3"
            role="alert"
          >
            {{ error_message }}
            <button
              type="button"
              class="btn-close"
              @click="error_message = ''"
            ></button>
          </div>

          <!-- Success -->
          <div
            v-if="success_message"
            class="alert alert-success alert-dismissible fade show rounded-3"
            role="alert"
          >
            {{ success_message }}
            <button
              type="button"
              class="btn-close"
              @click="success_message = ''"
            ></button>
          </div>

          <!-- Loading -->
          <div v-if="is_loading" class="text-center mb-3">
            <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
            <span class="text-white-50">Updating password...</span>
          </div>

          <!-- ==========================
                CREATE PASSWORD FORM
          =========================== -->
          <form @submit.prevent="submitNewPassword" v-if="!is_loading">

            <!-- New Password -->
            <div class="mb-3">
              <label class="form-label text-xs text-white-50 mb-1">New Password</label>
              <div class="position-relative">
                <input
                  v-model="password"
                  :type="password_input_type"
                  class="form-control form-control-sm rounded-3 pe-5
                        bg-transparent text-white border-secondary placeholder-white"
                  placeholder="Enter password"
                  required
                />
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="mb-3">
              <label class="form-label text-xs text-white-50 mb-1">Confirm Password</label>
              <div class="position-relative">
                <input
                  v-model="confirmPassword"
                  :type="password_input_type"
                  class="form-control form-control-sm rounded-3 pe-5
                        bg-transparent text-white border-secondary placeholder-white"
                  placeholder="Enter password"
                  required
                />
                <button
                  type="button"
                  class="btn position-absolute top-50 end-0 translate-middle-y text-white-50 px-2"
                  @click="toggle_change_password_type"
                  :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
                >
                  <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
            </div>

            <button class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3">
              Save New Password
            </button>

            <p class="text-center text-white-50 text-xs mb-0">
              Remember your password?
              <router-link to="/login" class="text-decoration-none text-primary">
                Login
              </router-link>
            </p>

          </form>

        </div>
      </div>

    </div>
  </div>
</div>
